import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../wayfinder'
/**
* @see \App\Http\Controllers\PodcastChartController::chartblock
* @see app/Http/Controllers/PodcastChartController.php:32
* @route '/charts'
*/
export const chartblock = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: chartblock.url(options),
    method: 'get',
})

chartblock.definition = {
    methods: ["get","head"],
    url: '/charts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PodcastChartController::chartblock
* @see app/Http/Controllers/PodcastChartController.php:32
* @route '/charts'
*/
chartblock.url = (options?: RouteQueryOptions) => {
    return chartblock.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastChartController::chartblock
* @see app/Http/Controllers/PodcastChartController.php:32
* @route '/charts'
*/
chartblock.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: chartblock.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PodcastChartController::chartblock
* @see app/Http/Controllers/PodcastChartController.php:32
* @route '/charts'
*/
chartblock.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: chartblock.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PodcastController::show
* @see app/Http/Controllers/PodcastController.php:24
* @route '/podcast/{id}/{slug}'
*/
export const show = (args: { id: string | number, slug: string | number } | [id: string | number, slug: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/podcast/{id}/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PodcastController::show
* @see app/Http/Controllers/PodcastController.php:24
* @route '/podcast/{id}/{slug}'
*/
show.url = (args: { id: string | number, slug: string | number } | [id: string | number, slug: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            id: args[0],
            slug: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
        slug: args.slug,
    }

    return show.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastController::show
* @see app/Http/Controllers/PodcastController.php:24
* @route '/podcast/{id}/{slug}'
*/
show.get = (args: { id: string | number, slug: string | number } | [id: string | number, slug: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PodcastController::show
* @see app/Http/Controllers/PodcastController.php:24
* @route '/podcast/{id}/{slug}'
*/
show.head = (args: { id: string | number, slug: string | number } | [id: string | number, slug: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\StaticPageController::aboutUs
* @see app/Http/Controllers/StaticPageController.php:7
* @route '/om'
*/
export const aboutUs = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutUs.url(options),
    method: 'get',
})

aboutUs.definition = {
    methods: ["get","head"],
    url: '/om',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\StaticPageController::aboutUs
* @see app/Http/Controllers/StaticPageController.php:7
* @route '/om'
*/
aboutUs.url = (options?: RouteQueryOptions) => {
    return aboutUs.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\StaticPageController::aboutUs
* @see app/Http/Controllers/StaticPageController.php:7
* @route '/om'
*/
aboutUs.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutUs.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\StaticPageController::aboutUs
* @see app/Http/Controllers/StaticPageController.php:7
* @route '/om'
*/
aboutUs.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: aboutUs.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\StaticPageController::aboutPodcast
* @see app/Http/Controllers/StaticPageController.php:12
* @route '/om-podcast'
*/
export const aboutPodcast = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutPodcast.url(options),
    method: 'get',
})

aboutPodcast.definition = {
    methods: ["get","head"],
    url: '/om-podcast',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\StaticPageController::aboutPodcast
* @see app/Http/Controllers/StaticPageController.php:12
* @route '/om-podcast'
*/
aboutPodcast.url = (options?: RouteQueryOptions) => {
    return aboutPodcast.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\StaticPageController::aboutPodcast
* @see app/Http/Controllers/StaticPageController.php:12
* @route '/om-podcast'
*/
aboutPodcast.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutPodcast.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\StaticPageController::aboutPodcast
* @see app/Http/Controllers/StaticPageController.php:12
* @route '/om-podcast'
*/
aboutPodcast.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: aboutPodcast.url(options),
    method: 'head',
})

/**
* @see \Illuminate\Routing\ViewController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/ViewController.php:32
* @route '/terms'
*/
export const terms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

terms.definition = {
    methods: ["get","head"],
    url: '/terms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Illuminate\Routing\ViewController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/ViewController.php:32
* @route '/terms'
*/
terms.url = (options?: RouteQueryOptions) => {
    return terms.definition.url + queryParams(options)
}

/**
* @see \Illuminate\Routing\ViewController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/ViewController.php:32
* @route '/terms'
*/
terms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

/**
* @see \Illuminate\Routing\ViewController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/ViewController.php:32
* @route '/terms'
*/
terms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: terms.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AuthController::login
* @see app/Http/Controllers/AuthController.php:41
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::login
* @see app/Http/Controllers/AuthController.php:41
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::login
* @see app/Http/Controllers/AuthController.php:41
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AuthController::login
* @see app/Http/Controllers/AuthController.php:41
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AuthController::register
* @see app/Http/Controllers/AuthController.php:102
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::register
* @see app/Http/Controllers/AuthController.php:102
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::register
* @see app/Http/Controllers/AuthController.php:102
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AuthController::register
* @see app/Http/Controllers/AuthController.php:102
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:168
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:168
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:168
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AccountController::dashboard
* @see app/Http/Controllers/AccountController.php:57
* @route '/mina-sidor'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/mina-sidor',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountController::dashboard
* @see app/Http/Controllers/AccountController.php:57
* @route '/mina-sidor'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::dashboard
* @see app/Http/Controllers/AccountController.php:57
* @route '/mina-sidor'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountController::dashboard
* @see app/Http/Controllers/AccountController.php:57
* @route '/mina-sidor'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

